import { io } from 'socket.io-client';
import type { Socket } from 'socket.io-client';
import { config } from './config.js';

let socket: Socket | null = null;

export function getSocket(token: string): Socket {
  if (socket && socket.connected) return socket;
  if (socket) socket.disconnect();
  socket = io(`${config.socketUrl}/game`, {
    path: config.socketPath,
    auth: { token },
    autoConnect: true,
    reconnection: true,
    reconnectionDelay: 800,
    reconnectionDelayMax: 4000,
    reconnectionAttempts: Infinity,
    transports: ['websocket', 'polling'],
  });
  return socket;
}

export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export function currentSocket(): Socket | null {
  return socket;
}
